<template>
  <div :class="[active?'active-grasimi':'']">
    <div class="row height-row" @click="active=!active" data-toggle="collapse" data-target="#alte2plus">
      <div class="col-md-4 col-4 border-table">
        <span v-if="!active" class="plus">+</span>
        <span v-else class="minus">-</span>
        <span class="span-black pl-0">Alte substanțe</span>
      </div>
      <div class="col-md-4 col-4 border-table"><span class="span-black" v-if="active"></span></div>
      <div class="col-md-4 col-4 border-table border-last"><span class="span-black" v-if="active"></span></div>
    </div>

    <div id="alte2plus" class="collapse">
      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">L-carnitină</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">15 mg</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">2.0 mg</span></div>
      </div>

      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Colină</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">156 mg</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">21 mg</span></div>
      </div>

      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Taurină*</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">0.94 mg</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">0.13 mg</span></div>
      </div>

      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Carbohidrați non-calorici (GOS)</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">1.7 g</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">0.2 g</span></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "alte",
  data() {
    return {
      active: false
    }
  }
}
</script>

<style scoped>

</style>
